<template>
  <div id="app">
    <el-container>
      <el-header class="navbar-container">
        <!-- 导航栏重新设计 -->
        <div class="navbar">
          <!-- 左侧导航区域 -->
          <div class="navbar-left">
            <!-- 网站Logo -->
            <div class="navbar-logo" @click="$router.push('/')">
              <!-- 桌面端logo -->
              <img 
                v-if="siteLogo.desktop"
                :src="siteLogo.desktop"
                alt="CARDESIGNSPACE" 
                class="logo-image logo-desktop"
              />
              <!-- 移动端logo -->
              <img 
                v-if="siteLogo.mobile"
                :src="siteLogo.mobile"
                alt="CARDESIGNSPACE" 
                class="logo-image logo-mobile"
              />
            </div>
          </div>

          <!-- 中间搜索区域 -->
          <div class="navbar-center">
            <div class="search-box">
              <el-input 
                :placeholder="searchPlaceholder" 
                v-model="searchKeyword"
                class="search-input mobile-search-input"
                @keyup.enter.native="handleSearch"
                clearable
                size="medium"
              >
                <el-button 
                  slot="append" 
                  icon="el-icon-search"
                  @click="handleSearch"
                ></el-button>
              </el-input>
            </div>
          </div>
          
          <!-- 右侧导航菜单 -->
          <div class="navbar-right">
            <!-- 桌面端导航菜单 -->
            <div class="navbar-menu desktop-menu">
              <el-menu mode="horizontal" router class="nav-menu-items">
                <el-menu-item index="/" class="nav-item">
                  <span>首页</span>
                </el-menu-item>
                <el-menu-item index="/articles" class="nav-item">
                  <span>资讯</span>
                </el-menu-item>
                <!-- <el-menu-item index="/smart-search" class="nav-item">
                  <span>智能搜索</span>
                </el-menu-item> -->
                <el-menu-item index="/image-gallery" class="nav-item">
                  <span>标签搜索</span>
                </el-menu-item>
                <el-menu-item index="/forum" class="nav-item">
                  <span>论坛</span>
                </el-menu-item>
                <el-menu-item index="/upload" class="nav-item">
                  <span>上传</span>
                </el-menu-item>
                <el-menu-item index="/donate" class="nav-item">
                  <span>赞助</span>
                </el-menu-item>
                <el-menu-item index="/about" class="nav-item">
                  <span>关于我们</span>
                </el-menu-item>
                <!-- <el-menu-item v-if="user" index="/articles/edit" class="nav-item">
                  <span>写文章</span>
                </el-menu-item> -->
              </el-menu>
            </div>

            <!-- 移动端下拉菜单 -->
            <div class="mobile-menu">
              <el-dropdown @command="handleMobileMenuCommand" placement="bottom-end">
                <div class="mobile-menu-trigger">
                  <i class="el-icon-menu"></i>
                  <span class="mobile-menu-text">菜单</span>
                </div>
                <el-dropdown-menu slot="dropdown" class="mobile-dropdown-menu">
                  <el-dropdown-item command="/">
                    <i class="el-icon-house"></i>
                    首页
                  </el-dropdown-item>
                  <el-dropdown-item command="/articles">
                    <i class="el-icon-document"></i>
                    <span>资讯</span>
                  </el-dropdown-item>
                  <el-dropdown-item command="/image-gallery">
                    <i class="el-icon-picture-outline"></i>
                    标签搜索
                  </el-dropdown-item>
                  <el-dropdown-item command="/forum">
                    <i class="el-icon-chat-dot-round"></i>
                    论坛
                  </el-dropdown-item>
                  <el-dropdown-item command="/upload">
                    <i class="el-icon-upload"></i>
                    上传
                  </el-dropdown-item>
                  <el-dropdown-item command="/donate">
                    <i class="el-icon-coin"></i>
                    赞助
                  </el-dropdown-item>
                  <el-dropdown-item command="/about">
                    <i class="el-icon-info"></i>
                    关于
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>

            <!-- 用户未登录时显示登录注册 -->
            <template v-if="!user">
              <div class="auth-buttons">
                <el-button type="text" @click="showAuthDialog('login')" class="login-btn">
                  登录
                </el-button>
                <el-button type="primary" size="small" @click="showAuthDialog('register')" class="register-btn">
                  注册
                </el-button>
              </div>
            </template>
            
            <!-- 用户已登录时显示功能区 -->
            <template v-else>
              <div class="user-functions">
                <!-- 消息通知 -->
                <div class="notification-wrapper">
                  <NotificationCenter />
                </div>
                
                <!-- 用户头像菜单 -->
                <div class="user-menu-wrapper">
                  <el-dropdown @command="handleUserMenuCommand" placement="bottom-end">
                    <div class="user-profile-trigger">
                      <el-avatar 
                        :size="36" 
                        :src="user.avatar" 
                        icon="el-icon-user-solid"
                        class="user-avatar clickable-avatar"
                      ></el-avatar>
                      <span class="username clickable-username">{{ user.username }}</span>
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown" class="user-dropdown-menu">
                      <el-dropdown-item command="points" class="points-dropdown-item">
                        <i class="el-icon-star-on" style="color: #f39c12;"></i>
                        <span class="dropdown-points-label">我的积分</span>
                        <span class="dropdown-points-value">{{ user.points || 0 }}</span>
                      </el-dropdown-item>
                      <el-dropdown-item divided command="profile">
                        <i class="el-icon-user"></i>
                        个人资料
                      </el-dropdown-item>
                      <el-dropdown-item command="favorites">
                        <i class="el-icon-star-on"></i>
                        我的收藏
                      </el-dropdown-item>
                      <el-dropdown-item command="uploads">
                        <i class="el-icon-upload"></i>
                        我的上传
                      </el-dropdown-item>
                      <el-dropdown-item command="image-tagging">
                        <i class="el-icon-edit"></i>
                        图片标签管理
                      </el-dropdown-item>
                      <el-dropdown-item command="image-gallery">
                        <i class="el-icon-picture"></i>
                        图片分类浏览
                      </el-dropdown-item>
                      <el-dropdown-item divided command="logout">
                        <i class="el-icon-switch-button"></i>
                        退出登录
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </template>
          </div>
        </div>
      </el-header>
      <el-main>
        <router-view @user-updated="updateUser" />
      </el-main>
    </el-container>
    
    <!-- 认证弹窗 -->
    <AuthDialog
      :show.sync="authDialogVisible"
      :mode="authMode"
      @login-success="onLoginSuccess"
    />
  </div>
</template>

<script>
import AuthDialog from './components/AuthDialog.vue'
import NotificationCenter from './components/NotificationCenter.vue'
import axios from 'axios'
import { apiClient, authAPI } from './services/api'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'App',
  components: {
    AuthDialog,
    NotificationCenter
  },
  data() {
    return {
      authDialogVisible: false,
      authMode: 'login',
      searchKeyword: '',
      siteLogo: {
        desktop: '',
        mobile: ''
      },
      keepAliveInterval: null, // 心跳检测定时器
      lastActiveTime: Date.now(), // 上次活跃时间
      isPageVisible: true, // 页面是否可见
    }
  },
  computed: {
    ...mapState(['user', 'isAuthenticated']),
    searchPlaceholder() {
      // 检测屏幕宽度来显示不同的placeholder
      if (typeof window !== 'undefined' && window.innerWidth <= 768) {
        return '搜索品牌或车型'
      }
      return '搜索您感兴趣的汽车品牌或车型'
    }
  },
  mounted() {
    this.setupAxiosInterceptors()
    this.initializeAuth()
    this.loadSiteLogo()
    // 监听窗口大小变化以更新placeholder
    window.addEventListener('resize', this.handleResize)
    // 监听认证错误事件（由 apiClient 拦截器触发）
    window.addEventListener('auth:error', this.handleAuthError)
    
    // 添加滚动恢复机制 - 防止某些情况下页面滚动失效
    this.setupScrollRestoration()
    
    // 启动心跳检测机制
    this.startKeepAlive()
    
    // 监听页面可见性变化
    this.setupVisibilityListener()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('auth:error', this.handleAuthError)
    // 清理页面可见性监听
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
    // 清理滚动恢复监听器
    if (this.scrollRestorationUnwatch) {
      this.scrollRestorationUnwatch()
    }
    // 清理定时器
    if (this.scrollCheckInterval) {
      clearInterval(this.scrollCheckInterval)
    }
    // 清理心跳检测定时器
    if (this.keepAliveInterval) {
      clearInterval(this.keepAliveInterval)
    }
  },
      methods: {
    ...mapActions(['login', 'logout', 'updateUser', 'checkAuth']),

    async loadSiteLogo() {
      try {
        const response = await apiClient.get('/site-assets/logo')
        if (response && response.status === 'success' && response.data) {
          this.siteLogo = {
            desktop: response.data.desktop || this.siteLogo.desktop,
            mobile: response.data.mobile || this.siteLogo.mobile
          }
        }
      } catch (error) {
        console.warn('站点Logo加载失败，回退默认地址:', error.message || error)
      }
    },
    
    // 设置滚动恢复机制
    setupScrollRestoration() {
      // 监听路由变化，确保页面滚动始终正常
      this.scrollRestorationUnwatch = this.$router.afterEach((to, from) => {
        // 确保body和html的overflow属性正常
        this.$nextTick(() => {
          // 移除可能被误设置的overflow: hidden
          if (document.body.style.overflow === 'hidden') {
            document.body.style.overflow = ''
          }
          // 确保html元素可以滚动
          if (document.documentElement.style.overflow === 'hidden') {
            document.documentElement.style.overflow = ''
          }
        })
      })
      
      // 定期检查滚动状态（每10秒）- 作为防御性措施，减少检查频率以提升性能
      this.scrollCheckInterval = setInterval(() => {
        // 如果没有打开任何模态框或图片查看器，确保页面可以滚动
        const hasModal = document.querySelector('.el-dialog__wrapper') || 
                        document.querySelector('.image-viewer-overlay') ||
                        document.querySelector('.inspiration-image-modal')
        
        if (!hasModal) {
          if (document.body.style.overflow === 'hidden') {
            console.warn('检测到页面滚动被锁定，正在恢复...')
            document.body.style.overflow = ''
          }
        }
      }, 10000)
    },
    
    // 处理窗口大小变化
    handleResize() {
      this.$forceUpdate() // 强制更新组件以重新计算placeholder
    },
    
    // 处理认证错误事件
    handleAuthError(event) {
      const { message } = event.detail || {}
      console.log('🔐 收到认证错误事件:', event.detail)
      
      // 清除用户数据
      this.clearUserData()
      
      // 显示错误消息
      if (message) {
        this.$message.error(message)
      } else {
        this.$message.error('登录已过期，请重新登录')
      }
    },
    
    // 初始化认证状态
    async initializeAuth() {
      // 检查并恢复用户会话
      await this.checkAuth()
    },
    
    // 设置axios拦截器
    setupAxiosInterceptors() {
      // 请求拦截器：添加token
      axios.interceptors.request.use(
        config => {
          const token = localStorage.getItem('token')
          console.log('🔐 请求拦截器:', {
            url: config.url,
            method: config.method,
            hasToken: !!token,
            tokenPreview: token ? token.substring(0, 20) + '...' : '无token'
          })
          if (token) {
            config.headers.Authorization = `Bearer ${token}`
            console.log('✅ 已添加Authorization头')
          } else {
            console.log('❌ 没有token，未添加Authorization头')
          }
          return config
        },
        error => {
          return Promise.reject(error)
        }
      )
      
      // 响应拦截器：处理token过期和自动重试
      axios.interceptors.response.use(
        response => response,
        async error => {
          console.log('🚨 拦截器捕获错误:', {
            url: error.config && error.config.url,
            status: error.response && error.response.status,
            data: error.response && error.response.data,
            message: error.message
          })
          
          // 处理网络错误或连接超时，自动重试
          if (!error.response && error.config && !error.config.__retryCount) {
            error.config.__retryCount = 1
            console.log('🔄 网络错误，自动重试请求...')
            try {
              // 等待1秒后重试
              await new Promise(resolve => setTimeout(resolve, 1000))
              return axios.request(error.config)
            } catch (retryError) {
              console.log('❌ 重试失败:', retryError.message)
              this.$message.error('网络连接失败，请检查网络后重试')
              return Promise.reject(retryError)
            }
          }
          
          // 只有在非checkAuth请求时才显示消息和清除数据
          // checkAuth请求应该自己处理错误
          if (error.response && error.response.status === 401) {
            const isCheckAuthRequest = error.config && error.config.url && error.config.url.includes('/api/auth/me')
            const isArticleRequest = error.config && error.config.url && error.config.url.includes('/api/articles')
            
            // 检查是否是真的认证错误（包含认证相关的错误信息）
            const errorMessage = (error.response && error.response.data && error.response.data.message) || ''
            const isAuthError = errorMessage.includes('认证') || errorMessage.includes('token') || errorMessage.includes('登录')
            
            console.log('🔍 401错误分析:', {
              isCheckAuthRequest,
              isArticleRequest,
              errorMessage,
              isAuthError,
              url: error.config && error.config.url
            })
            
            // 特殊处理"The user belonging to this token no longer exists"错误
            if (errorMessage.includes('The user belonging to this token no longer exists')) {
              console.log('💥 用户不存在，立即清除用户数据')
              this.clearUserData()
              this.$message.error('用户账户不存在，请重新登录')
              return Promise.reject(error)
            }
            
            // 对于文章相关请求，不在这里清除用户数据，让具体的组件处理
            if (isArticleRequest) {
              console.log('ℹ️ 文章请求401错误，让组件自行处理')
              return Promise.reject(error)
            }
            
            // 只有在特定的认证错误时才清除用户数据
            // 避免因为偶发问题就清除用户会话
            if (!isCheckAuthRequest && 
                (errorMessage.includes('invalid signature') || 
                 errorMessage.includes('expired') || 
                 errorMessage.includes('malformed'))) {
              console.log('💥 清除用户数据，显示登录过期消息')
              this.clearUserData()
              this.$message.warning('登录已过期，请重新登录')
            } else if (!isCheckAuthRequest) {
              // 对于偶发的401错误，尝试自动重试一次
              if (!error.config.__retryCount) {
                error.config.__retryCount = 1
                console.log('🔄 401错误可能是临时的，尝试自动重试...')
                try {
                  // 等待500ms后重试
                  await new Promise(resolve => setTimeout(resolve, 500))
                  return axios.request(error.config)
                } catch (retryError) {
                  console.log('❌ 重试失败，显示错误提示')
                  // 更友好的错误提示
                  this.$message({
                    type: 'warning',
                    message: '网络连接似乎有问题，请稍后再试',
                    duration: 3000
                  })
                  return Promise.reject(retryError)
                }
              } else {
                console.log('ℹ️ 已重试过，显示错误消息')
                // 更友好的错误提示
                this.$message({
                  type: 'warning',
                  message: '网络连接似乎有问题，请稍后再试',
                  duration: 3000
                })
              }
            }
          }
          return Promise.reject(error)
        }
      )
    },
    
    // 显示认证弹窗
    showAuthDialog(mode) {
      this.authMode = mode
      this.authDialogVisible = true
    },
    
    // 登录成功回调
    onLoginSuccess(data) {
      this.login(data)
      localStorage.setItem('token', data.token)
      localStorage.setItem('user', JSON.stringify(data.user))
      this.$message.success(`欢迎回来，${data.user.username}！`)
    },
    
    // 处理用户菜单命令
    handleUserMenuCommand(command) {
      switch (command) {
        case 'points':
          this.$router.push('/profile')
          break
        case 'profile':
          this.$router.push('/profile')
          break
        case 'favorites':
          this.$router.push({ path: '/profile', query: { tab: 'favorites' } })
          break
        case 'uploads':
          this.goToMyUploads()
          break
        case 'image-tagging':
          this.$router.push('/image-tagging')
          break
        case 'image-gallery':
          this.$router.push('/image-gallery')
          break
        case 'logout':
          this.handleLogout()
          break
      }
    },
    
    // 退出登录
    async handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          // 调用后端退出登录API
          await authAPI.logout()
          this.clearUserData()
          this.$message.success('已退出登录')
        } catch (error) {
          console.error('调用退出登录API失败:', error)
          // 即使API调用失败，也清除本地数据
          this.clearUserData()
          this.$message.success('已退出登录')
        }
      }).catch(() => {
        // 用户取消退出
      })
    },
    
    // 清除用户数据
    clearUserData() {
      this.logout()
      localStorage.removeItem('token')
      localStorage.removeItem('user')
    },

    // 导航到我的上传页面
    goToMyUploads() {
      this.$router.push({ path: '/profile', query: { tab: 'uploads' } })
    },

    // 导航到个人主页
    goToProfile() {
      this.$router.push('/profile')
    },

    // 处理搜索
    handleSearch() {
      if (!this.searchKeyword.trim()) return;
      this.$router.push({
        path: '/search',
        query: { keyword: this.searchKeyword.trim() }
      });
    },

    // 处理移动端菜单命令
    handleMobileMenuCommand(command) {
      this.$router.push(command);
    },
    
    // 心跳检测机制 - 保持连接活跃
    startKeepAlive() {
      // 如果用户已登录，每2分钟发送一次心跳检测请求
      this.keepAliveInterval = setInterval(async () => {
        // 只在页面可见时才发送心跳
        if (this.isPageVisible && this.isAuthenticated && localStorage.getItem('token')) {
          try {
            // 发送轻量级的认证检查请求
            await authAPI.checkAuth()
            this.lastActiveTime = Date.now()
            console.log('💓 心跳检测：连接正常')
          } catch (error) {
            console.warn('⚠️ 心跳检测失败，但不清除用户数据:', error.message)
            // 心跳失败不清除用户数据，让用户下次操作时再处理
          }
        }
      }, 120000) // 2分钟
    },
    
    // 设置页面可见性监听
    setupVisibilityListener() {
      const handleVisibilityChange = async () => {
        if (document.hidden) {
          // 页面变为不可见
          this.isPageVisible = false
          console.log('📱 页面变为不可见')
        } else {
          // 页面重新可见
          this.isPageVisible = true
          console.log('👁️ 页面重新可见')
          
          // 如果用户已登录，检查是否需要重新验证session
          if (this.isAuthenticated && localStorage.getItem('token')) {
            const inactiveTime = Date.now() - this.lastActiveTime
            const inactiveMinutes = Math.floor(inactiveTime / 60000)
            
            console.log(`⏱️ 页面不活跃时间: ${inactiveMinutes} 分钟`)
            
            // 如果不活跃时间超过3分钟，主动验证一次session
            if (inactiveMinutes >= 3) {
              console.log('🔄 页面长时间不活跃，正在重新验证session...')
              try {
                await authAPI.checkAuth()
                this.lastActiveTime = Date.now()
                console.log('✅ Session验证成功')
              } catch (error) {
                console.warn('⚠️ Session验证失败:', error.message)
                // 如果是认证错误，提示用户重新登录
                if (error.response && error.response.status === 401) {
                  this.$message.warning('登录已过期，请重新登录')
                  this.clearUserData()
                }
              }
            } else {
              // 更新最后活跃时间
              this.lastActiveTime = Date.now()
            }
          }
        }
      }
      
      // 绑定事件并保存引用以便后续清理
      this.handleVisibilityChange = handleVisibilityChange
      document.addEventListener('visibilitychange', handleVisibilityChange)
    }
  }
}
</script>

<style>
/* 全局防止水平滚动和双重滚动条 */
html {
  overflow-x: clip !important;
  overflow-y: auto !important;
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  min-height: 100%;
  height: auto;
  position: relative;
}

body {
  overflow-x: clip !important;
  overflow-y: visible !important;
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  background: #0a0a0a;
  min-height: 100vh;
  height: auto; /* 允许 body 根据内容自动增长 */
  position: relative;
}

/* 当灵感图片模态框打开时隐藏导航栏 */
body:has(.inspiration-modal) .navbar-container {
  display: none !important;
}

/* 兼容性处理 - 为不支持:has的浏览器 */
.modal-open .navbar-container {
  display: none !important;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  background: #0a0a0a;
  min-height: 100vh;
  height: auto; /* 允许根据内容自动增长 */
  position: relative;
}

/* Element UI 容器重置：保持普通文档流滚动，避免多层滚动容器冲突 */
.el-container {
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  background: #0a0a0a;
  min-height: 100vh;
  overflow-x: clip !important;
  overflow-y: visible !important;
  display: block !important;
  position: relative !important;
}

.el-header {
  padding: 0 !important;
  margin: 0 !important;
  width: 100% !important;
}

.el-main {
  padding: 0 !important;
  margin: 0 !important;
  margin-top: 60px !important; /* 为固定导航栏留出空间 */
  overflow-x: clip !important;
  overflow-y: visible !important;
  display: block !important;
  position: relative !important;
}

/* ===== 全站资料库风格统一 ===== */
:root {
  --archive-bg: #f6f4ee;
  --archive-paper: #fffdf8;
  --archive-paper-soft: #faf8f0;
  --archive-line: #d9d3c6;
  --archive-ink: #171511;
  --archive-muted: #70695e;
  --archive-red: #e03426;
  --archive-red-hover: #f04838;
}

.el-main {
  background:
    linear-gradient(90deg, rgba(224, 52, 38, 0.045) 0 1px, transparent 1px),
    linear-gradient(180deg, rgba(224, 52, 38, 0.035) 0 1px, transparent 1px),
    var(--archive-bg) !important;
  background-size: 56px 56px !important;
}

.articles-page,
.brand-detail,
.model-detail,
.search,
.smart-search-modern,
.image-gallery,
.image-similarity-page,
.inspiration-page,
.forum-page,
.profile-page,
.about-page,
.donate-page,
.image-tagging-page,
.upload-page,
.drafts-page,
.series,
.models {
  min-height: calc(100vh - 60px);
  color: var(--archive-ink);
  background:
    linear-gradient(90deg, rgba(224, 52, 38, 0.045) 0 1px, transparent 1px),
    linear-gradient(180deg, rgba(224, 52, 38, 0.035) 0 1px, transparent 1px),
    var(--archive-bg);
  background-size: 56px 56px;
}

.articles-page .container,
.drafts-page .container,
.search .search-toolbar,
.search .advanced-filters,
.search .search-results,
.brand-detail > div:not(.loading-container):not(.error-message),
.model-detail .model-content,
.smart-search-modern .hero-content,
.smart-search-modern .results-container,
.image-gallery .gallery-container,
.image-similarity-page .hero-content,
.image-similarity-page .results-container {
  max-width: 1320px;
  margin-right: auto;
  margin-left: auto;
}

.page-header,
.search-header,
.hero-section,
.brand-header,
.model-header,
.filters-section,
.model-filter-section,
.results-header,
.stats-bar,
.filter-sidebar,
.content-area,
.articles-section,
.featured-section,
.images-section,
.model-list,
.upload-card,
.results-section {
  background: transparent;
}

.page-header .container,
.search-header,
.hero-content,
.brand-header,
.model-header,
.filters-section .container,
.model-filter-section,
.filter-sidebar,
.content-area,
.results-container,
.articles-section .container,
.featured-section .container,
.images-section,
.model-list,
.search-toolbar,
.advanced-filters {
  border: 1px solid var(--archive-line);
  border-radius: 0;
  background: rgba(255, 253, 248, 0.9);
  box-shadow: none;
}

.page-header .container,
.search-header,
.hero-content,
.brand-header,
.model-header {
  padding: 34px 36px;
  border-color: #29251f;
}

.page-title,
.search-header h1,
.brand-info h1,
.model-title h1,
.section-title,
.model-filter-section h2,
.results-title {
  color: var(--archive-ink) !important;
  font-weight: 900 !important;
  letter-spacing: -0.04em;
}

.page-subtitle,
.page-description,
.search-header p,
.brand-info p,
.featured-summary,
.loading-text {
  color: var(--archive-muted) !important;
}

.article-card,
.featured-article,
.model-card,
.image-card,
.stat-card,
.result-card,
.gallery-item,
.upload-card,
.el-card {
  border: 1px solid var(--archive-line) !important;
  border-radius: 0 !important;
  background: var(--archive-paper) !important;
  box-shadow: none !important;
}

.article-card:hover,
.featured-article:hover,
.model-card:hover,
.image-card:hover,
.gallery-item:hover,
.upload-card:hover {
  border-color: var(--archive-red) !important;
  box-shadow: 0 16px 34px rgba(39, 35, 29, 0.14) !important;
}

.el-input__inner,
.el-textarea__inner,
.el-select .el-input__inner {
  border-radius: 0 !important;
  border-color: var(--archive-line) !important;
  background: var(--archive-paper) !important;
  color: var(--archive-ink) !important;
}

.el-input__inner:focus,
.el-textarea__inner:focus {
  border-color: var(--archive-red) !important;
  box-shadow: 3px 3px 0 rgba(224, 52, 38, 0.18) !important;
}

.el-button {
  border-radius: 0 !important;
}

.el-tag,
.category-tag,
.quick-tag,
.filter-btn,
.sort-btn,
.concept-btn {
  border-radius: 0 !important;
}

.el-tag--primary,
.category-tag.el-tag--primary,
.filter-btn.active,
.quick-tag:hover {
  color: #fff !important;
  background: var(--archive-red) !important;
  border-color: var(--archive-red) !important;
}

/* 首页同款三栏资料库骨架，供文章页与智能搜索页复用 */
.archive-page-layout {
  display: grid;
  grid-template-columns: 260px minmax(0, 1fr) 300px;
  max-width: 1560px;
  height: calc(100vh - 60px);
  max-height: calc(100vh - 60px);
  margin: 0 auto;
  overflow: hidden;
  border-right: 1px solid var(--archive-line);
  border-left: 1px solid var(--archive-line);
  background:
    linear-gradient(90deg, var(--archive-paper-soft) 0 260px, rgba(255, 253, 246, 0.78) 260px calc(100% - 300px), var(--archive-paper-soft) calc(100% - 300px));
}

.archive-side-panel,
.archive-reference-panel {
  min-height: 0;
  padding: 28px 20px;
  overflow: hidden;
  background: var(--archive-paper-soft);
}

.archive-side-panel {
  border-right: 1px solid var(--archive-line);
}

.archive-reference-panel {
  border-left: 1px solid var(--archive-line);
}

.archive-main-panel {
  min-width: 0;
  min-height: 0;
  padding: 28px 46px 36px;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}

.archive-brand-mark {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding-bottom: 24px;
  margin-bottom: 22px;
  border-bottom: 1px solid #29251f;
}

.archive-brand-dot {
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  margin-top: 2px;
  background: var(--archive-red);
  border-radius: 50%;
  box-shadow: 24px 0 0 #1f1c18;
}

.archive-brand-mark p,
.archive-side-note span,
.archive-reference-label {
  margin: 0;
  color: var(--archive-red);
  font-size: 11px;
  font-weight: 800;
  line-height: 22px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.archive-brand-mark p {
  padding-left: 18px;
}

.archive-brand-mark strong {
  display: block;
  margin-top: 7px;
  color: var(--archive-ink);
  font-size: 18px;
  line-height: 1.35;
}

.archive-nav {
  display: grid;
  gap: 4px;
}

.archive-nav-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 8px;
  color: #3d3932;
  text-decoration: none;
  border-left: 3px solid transparent;
}

.archive-nav-link:hover,
.archive-nav-link.active {
  color: var(--archive-red);
  background: #eeece3;
  border-left-color: var(--archive-red);
}

.archive-nav-link em {
  color: #9a9487;
  font-size: 11px;
  font-style: normal;
}

.archive-side-note {
  margin-top: 28px;
  padding: 16px;
  background: var(--archive-paper);
  border: 1px solid var(--archive-line);
}

.archive-side-note p {
  margin: 8px 0 0;
  color: var(--archive-muted);
  font-size: 13px;
  line-height: 1.7;
}

.archive-reference-block {
  padding: 20px 0;
  border-bottom: 1px solid #e2dbce;
}

.archive-reference-block:first-child {
  padding-top: 0;
}

.archive-reference-link,
.archive-reference-empty,
.archive-reference-button {
  display: block;
  width: 100%;
  margin-top: 10px;
  padding: 0 0 0 12px;
  color: #5e584e;
  font: inherit;
  font-size: 13px;
  line-height: 1.65;
  text-align: left;
  text-decoration: none;
  background: transparent;
  border: none;
  border-left: 3px solid #d8d1c2;
  cursor: pointer;
}

.archive-reference-link:hover,
.archive-reference-button:hover {
  color: var(--archive-red);
  border-left-color: var(--archive-red);
}

@media (max-width: 1280px) {
  .archive-page-layout {
    grid-template-columns: 220px minmax(0, 1fr);
  }

  .archive-reference-panel {
    display: none;
  }
}

@media (max-width: 960px) {
  .archive-page-layout {
    display: block;
    height: auto;
    max-height: none;
    overflow: visible;
    border-right: none;
    border-left: none;
  }

  .archive-side-panel {
    padding: 18px 16px;
    border-right: none;
    border-bottom: 1px solid var(--archive-line);
  }

  .archive-nav {
    display: flex;
    gap: 8px;
    overflow-x: auto;
  }

  .archive-nav-link {
    flex: 0 0 auto;
    gap: 16px;
    border-left: none;
    border-bottom: 3px solid transparent;
  }

  .archive-nav-link:hover,
  .archive-nav-link.active {
    border-left-color: transparent;
    border-bottom-color: var(--archive-red);
  }

  .archive-side-note {
    display: none;
  }

  .archive-main-panel {
    padding: 20px 16px 28px;
    overflow: visible;
  }
}

/* ===== Element UI 主题色覆盖 ===== */
/* 覆盖 Element UI 的主色调 */
.el-button--primary {
  background-color: #e03426 !important;
  border-color: #e03426 !important;
}

.el-button--primary:hover, 
.el-button--primary:focus {
  background-color: #f04838 !important;
  border-color: #f04838 !important;
}

.el-button--primary:active {
  background-color: #d02e20 !important;
  border-color: #d02e20 !important;
}

.el-button--primary.is-disabled {
  background-color: #f0a3a3 !important;
  border-color: #f0a3a3 !important;
}

/* Tag primary */
.el-tag--primary {
  background-color: #e03426 !important;
  border-color: #e03426 !important;
}

/* Link color */
.el-link--primary {
  color: #e03426 !important;
}

.el-link--primary:hover {
  color: #f04838 !important;
}

/* Loading primary */
.el-loading-spinner .el-loading-text {
  color: #e03426 !important;
}

/* Switch primary */
.el-switch.is-checked .el-switch__core {
  background-color: #e03426 !important;
  border-color: #e03426 !important;
}

/* Checkbox primary */
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #e03426 !important;
  border-color: #e03426 !important;
}

/* Radio primary */
.el-radio__input.is-checked .el-radio__inner {
  background-color: #e03426 !important;
  border-color: #e03426 !important;
}

/* Progress primary */
.el-progress-bar__inner {
  background-color: #e03426 !important;
}

/* Slider primary */
.el-slider__button {
  border-color: #e03426 !important;
}

.el-slider__bar {
  background-color: #e03426 !important;
}

/* Menu 菜单项强制覆盖 - 仅作用于导航栏，与浅色资料库风格一致 */
.navbar-container .el-menu--horizontal > .el-menu-item,
.navbar-container .el-menu--horizontal > .el-submenu > .el-submenu__title {
  background-color: transparent !important;
  color: #29251f !important;
}

.navbar-container .el-menu--horizontal > .el-menu-item:hover,
.navbar-container .el-menu--horizontal > .el-submenu > .el-submenu__title:hover {
  background-color: #eeece3 !important;
  color: #e03426 !important;
}

.navbar-container .el-menu--horizontal > .el-menu-item.is-active {
  background-color: #eeece3 !important;
  color: #e03426 !important;
  border-bottom: none !important;
}

.navbar-container .el-menu--horizontal > .el-menu-item span,
.navbar-container .el-menu--horizontal > .el-submenu > .el-submenu__title span {
  color: inherit !important;
}

/* 更强制的菜单项样式覆盖 */
.navbar .el-menu-item,
.navbar .el-menu-item:hover,
.navbar .el-menu-item:focus,
.navbar .el-menu-item.is-active,
.navbar .el-menu-item.is-active:hover {
  background-color: transparent !important;
  background: transparent !important;
}

.navbar .nav-item,
.navbar .nav-item:hover,
.navbar .nav-item:focus,
.navbar .nav-item.is-active,
.navbar .nav-item.is-active:hover {
  background-color: transparent !important;
  background: transparent !important;
  color: #29251f !important;
}

.navbar .nav-item:hover,
.navbar .nav-item.is-active,
.navbar .nav-item.is-active:hover {
  color: #e03426 !important;
}

.navbar .nav-submenu .el-submenu__title,
.navbar .nav-submenu .el-submenu__title:hover {
  color: #29251f !important;
}

.navbar .nav-submenu:hover .el-submenu__title,
.navbar .nav-submenu.is-active .el-submenu__title {
  color: #e03426 !important;
}

/* 终极覆盖 - 确保导航菜单项完全透明 */
.navbar-container .el-menu,
.navbar-container .el-menu-item,
.navbar-container .nav-item {
  background: none !important;
  background-color: transparent !important;
  background-image: none !important;
}

.navbar-container .el-menu-item::before,
.navbar-container .el-menu-item::after {
  display: none !important;
}

/* 强制所有状态下的透明背景 */
.navbar-container .el-menu-item[class*="is-"],
.navbar-container .el-menu-item[class*="el-"],
.navbar-container .nav-item[class*="is-"],
.navbar-container .nav-item[class*="el-"] {
  background: transparent !important;
  background-color: transparent !important;
}

/* 强制登录按钮白色文字 */
.navbar-container .login-btn,
.navbar-container .el-button.login-btn,
.navbar-container button.login-btn {
  color: #29251f !important;
  background-color: transparent !important;
  border: none !important;
}

.navbar-container .login-btn:hover,
.navbar-container .el-button.login-btn:hover,
.navbar-container button.login-btn:hover {
  color: #e03426 !important;
  background-color: #eeece3 !important;
}

.navbar-container .login-btn:focus,
.navbar-container .el-button.login-btn:focus,
.navbar-container button.login-btn:focus {
  color: #29251f !important;
  background-color: transparent !important;
}

/* ===== 导航栏样式 ===== */
.navbar-container {
  padding: 0 !important;
  background: rgba(250, 248, 240, 0.96) !important;
  border-bottom: 1px solid #29251f !important;
  width: 100% !important;
  max-width: 100% !important;
  box-shadow: none !important;
  overflow-x: clip !important;
  margin: 0 !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  z-index: 1000 !important;
}

/* 确保导航栏完全覆盖 */
.navbar-container::before,
.navbar-container::after {
  display: none !important;
}

.navbar {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  height: 60px !important;
  margin: 0 auto !important;
  padding: 0 18px !important;
  background:
    linear-gradient(90deg, rgba(224, 52, 38, 0.08) 0 1px, transparent 1px),
    rgba(250, 248, 240, 0.96) !important;
  background-size: 28px 28px !important;
  width: 100% !important;
  box-sizing: border-box !important;
  overflow: hidden !important;
}

/* 左侧导航区域 */
.navbar-left {
  display: flex;
  align-items: center;
  gap: 32px;
  min-width: 150px;
  flex-shrink: 0;
}

/* Logo样式 */
.navbar-logo {
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.navbar-logo:hover {
  opacity: 0.82;
}

.logo-image {
  height: 32px; /* 从40px减少到32px */
  width: auto;
  object-fit: contain;
  filter: contrast(1.08);
}

/* 响应式logo显示控制 */
.logo-desktop {
  display: block;
}

.logo-mobile {
  display: none;
}

.navbar-center {
  flex: 1;
  max-width: 400px;
  margin: 0 20px;
  min-width: 150px;
  overflow: hidden;
}

.search-box {
  width: 100%;
}

.search-input {
  width: 100%;
}

.search-input .el-input__inner {
  border-radius: 0;
  border-right: none;
  padding-left: 20px;
  background-color: #fffdf8;
  border-color: #29251f;
  color: #171511;
}

.search-input .el-input__inner::placeholder {
  color: #8a8375;
}

.search-input .el-input__inner:focus {
  border-color: #29251f;
  box-shadow: 3px 3px 0 rgba(224, 52, 38, 0.24);
}

.search-input .el-input-group__append {
  border-radius: 0;
  padding: 0 20px;
  background: #e03426;
  border-color: #e03426;
}

.search-input .el-input-group__append .el-button {
  border: none;
  color: white;
  padding: 0;
  margin: 0;
  background: #e03426;
}

.search-input .el-input-group__append .el-button:hover,
.search-input .el-input-group__append .el-button:focus {
  color: #fff;
  background: #f04838;
}

.navbar-right {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-shrink: 1;
  min-width: 0;
  overflow: hidden;
}

.navbar-menu {
  display: flex;
  align-items: center;
}

/* 重置Element UI默认样式 */
.nav-menu-items {
  border: none !important;
  background: transparent !important;
  border-bottom: none !important;
}

/* 重置Element UI默认样式 */
.nav-menu-items .el-menu-item {
  border-bottom: none !important;
  margin: 0 4px !important;
  padding: 0 !important;
  border-radius: 0 !important;
  background-color: transparent !important;
}

.nav-menu-items .el-menu-item::after {
  display: none !important;
}

.nav-menu-items .el-menu-item:not(.is-disabled):hover {
  background-color: #eeece3 !important;
  color: #e03426 !important;
}

.nav-menu-items .el-menu-item:not(.is-disabled):focus {
  background-color: #eeece3 !important;
  color: #e03426 !important;
}

.nav-menu-items .el-menu-item.is-active {
  border-bottom: none !important;
  background-color: #eeece3 !important;
  color: #e03426 !important;
}

/* 导航项样式 - 参考右侧设计 */
.nav-item {
  display: flex !important;
  align-items: center !important;
  gap: 0px !important;
  padding: 0 14px !important;
  height: 36px !important;
  border-bottom: none !important;
  transition: all 0.2s ease !important;
  color: #29251f !important;
  font-weight: 700 !important;
  border-radius: 0 !important;
  position: relative !important;
  margin: 0 !important;
  background-color: transparent !important;
  border: none !important;
}

.nav-item:hover {
  color: #e03426 !important;
  background-color: #eeece3 !important;
}

.nav-item.is-active {
  color: #e03426 !important;
  background-color: #eeece3 !important;
  font-weight: 800 !important;
}

.nav-item.is-active:hover {
  color: #e03426 !important;
  background-color: #eeece3 !important;
}

.nav-item span {
  font-size: 13px !important;
  font-weight: inherit !important;
  letter-spacing: 0.06em !important;
}

/* 导航下拉菜单样式 */
.nav-submenu.el-submenu {
  background-color: transparent !important;
  border: none !important;
}

.nav-submenu .el-submenu__title {
  display: flex !important;
  align-items: center !important;
  padding: 0 14px !important;
  height: 36px !important;
  border-bottom: none !important;
  transition: all 0.2s ease !important;
  color: #29251f !important;
  font-weight: 700 !important;
  border-radius: 0 !important;
  background-color: transparent !important;
  border: none !important;
}

.nav-submenu .el-submenu__title:hover {
  color: #e03426 !important;
  background-color: #eeece3 !important;
}

.nav-submenu .el-submenu__title i {
  color: inherit !important;
}

/* 下拉菜单弹出框样式 */
.el-menu--popup {
  background: #fffdf8 !important;
  border: 1px solid #29251f !important;
  border-radius: 0 !important;
  box-shadow: 4px 4px 0 #29251f !important;
  margin-top: 8px !important;
  padding: 8px 0 !important;
  min-width: 180px !important;
}

.el-menu--popup .el-menu-item {
  padding: 0 20px !important;
  height: 40px !important;
  line-height: 40px !important;
  color: #29251f !important;
  transition: all 0.2s ease !important;
  background-color: transparent !important;
  border-radius: 0 !important;
  display: flex !important;
  align-items: center !important;
  gap: 10px !important;
}

.el-menu--popup .el-menu-item:hover {
  color: #e03426 !important;
  background-color: #eeece3 !important;
}

.el-menu--popup .el-menu-item.is-active {
  color: #e03426 !important;
  background-color: #eeece3 !important;
  font-weight: 600 !important;
}

.el-menu--popup .el-menu-item i {
  font-size: 16px !important;
  color: inherit !important;
}

.el-menu--popup .el-menu-item span {
  font-size: 14px !important;
  color: inherit !important;
}

/* 确保下拉箭头正确显示 */
.nav-submenu .el-submenu__icon-arrow {
  color: #29251f !important;
  transition: all 0.2s ease !important;
  font-size: 12px !important;
  margin-left: 4px !important;
}

.nav-submenu:hover .el-submenu__icon-arrow {
  color: #e03426 !important;
}

/* 右侧用户区域 */
.navbar-right {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

/* 桌面端菜单 */
.desktop-menu {
  display: flex;
  align-items: center;
}

/* 移动端菜单 */
.mobile-menu {
  display: none;
}

.mobile-menu-trigger {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: #fffdf8;
  border: 1px solid #29251f;
  border-radius: 0;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #29251f;
}

.mobile-menu-trigger:hover {
  background: #eeece3;
  color: #e03426;
}

.mobile-menu-trigger i {
  font-size: 16px;
}

.mobile-menu-text {
  font-size: 12px;
  font-weight: 500;
}

.mobile-dropdown-menu {
  margin-top: 8px;
  border-radius: 0;
  box-shadow: 4px 4px 0 #29251f;
  border: 1px solid #29251f;
  overflow: hidden;
}

.mobile-dropdown-menu .el-dropdown-menu__item {
  padding: 12px 16px;
  font-size: 14px;
  color: #606266;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 10px;
}

.mobile-dropdown-menu .el-dropdown-menu__item:hover {
  background-color: #f5f7fa;
  color: #e03426;
}

.mobile-dropdown-menu .el-dropdown-menu__item i {
  font-size: 16px;
  width: 16px;
  text-align: center;
}

/* 登录注册按钮 */
.auth-buttons {
  display: flex;
  align-items: center;
  gap: 12px;
}

.login-btn {
  color: #29251f !important;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 0;
  transition: all 0.3s ease;
  background-color: transparent !important;
  border: none !important;
}

.login-btn:hover {
  color: #e03426 !important;
  background-color: #eeece3 !important;
}

.login-btn:focus {
  color: #29251f !important;
  background-color: transparent !important;
}

.register-btn {
  padding: 8px 20px;
  border-radius: 0;
  font-weight: 500;
  transition: all 0.3s ease;
}

.register-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

/* 用户功能区 */
.user-functions {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* 通知包装器 */
.notification-wrapper {
  display: flex;
  align-items: center;
}

/* 积分显示 */
/* 下拉菜单积分项样式 */
.points-dropdown-item {
  background-color: #f8f9fa !important;
  border-bottom: 1px solid #e9ecef !important;
  cursor: pointer !important;
}

.points-dropdown-item:hover {
  background-color: #e9ecef !important;
}

.points-dropdown-item .dropdown-points-label {
  flex: 1;
  margin-left: 4px;
  font-weight: 500;
}

.points-dropdown-item .dropdown-points-value {
  background: linear-gradient(135deg, #e03426, #ff6b4a);
  color: #ffffff;
  padding: 3px 10px;
  border-radius: 15px;
  font-size: 12px;
  font-weight: 600;
  margin-left: auto;
  box-shadow: 0 2px 4px rgba(224, 52, 38, 0.3);
  transition: all 0.3s ease;
}

.points-dropdown-item:hover .dropdown-points-value {
  transform: scale(1.05);
  box-shadow: 0 3px 6px rgba(224, 52, 38, 0.4);
}

/* 用户菜单 */
.user-menu-wrapper {
  margin-left: 20px;
}

.user-profile-trigger {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 20px;
  transition: all 0.3s ease;
}

.user-profile-trigger:hover {
  background-color: #eeece3;
}

.user-avatar {
  transition: all 0.3s ease;
}

.user-profile-trigger:hover .user-avatar {
  transform: scale(1.05);
}

.username {
  font-weight: 500;
  color: #29251f;
  font-size: 14px;
  transition: all 0.3s ease;
}

.user-profile-trigger:hover .username {
  color: #e03426;
}

.clickable-avatar {
  cursor: pointer;
}

.clickable-username {
  cursor: pointer;
}

/* 用户下拉菜单样式 */
.user-dropdown-menu {
  margin-top: 8px;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border: 1px solid #e4e7ed;
  overflow: hidden;
}

.user-dropdown-menu .el-dropdown-menu__item {
  padding: 12px 16px;
  font-size: 14px;
  color: #606266;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.user-dropdown-menu .el-dropdown-menu__item:hover {
  background-color: #f5f7fa;
  color: #e03426;
}

.user-dropdown-menu .el-dropdown-menu__item.is-divided {
  border-top: 1px solid #e4e7ed;
}

.user-dropdown-menu .el-dropdown-menu__item i {
  font-size: 16px;
  width: 16px;
  text-align: center;
}

/* 退出登录项特殊样式 */
.user-dropdown-menu .el-dropdown-menu__item[data-command="logout"] {
  color: #f56c6c;
}

.user-dropdown-menu .el-dropdown-menu__item[data-command="logout"]:hover {
  background-color: #fef0f0;
  color: #f56c6c;
}

/* 下拉箭头图标 */
.user-profile-trigger .el-icon-arrow-down {
  font-size: 12px;
  color: #29251f;
  transition: all 0.3s ease;
}

.user-profile-trigger:hover .el-icon-arrow-down {
  color: #e03426;
}

/* 用户头像下拉菜单最终配色覆盖 */
.user-profile-trigger {
  border: 1px solid transparent !important;
  border-radius: 0 !important;
}

.user-profile-trigger:hover {
  background: #eeece3 !important;
  border-color: #d9d3c6 !important;
}

.user-dropdown-menu {
  min-width: 220px !important;
  padding: 0 !important;
  background: #fffdf8 !important;
  border: 1px solid #29251f !important;
  border-radius: 0 !important;
  box-shadow: 4px 4px 0 #29251f !important;
  overflow: hidden !important;
}

.user-dropdown-menu .el-dropdown-menu__item {
  min-height: 42px !important;
  padding: 0 16px !important;
  color: #29251f !important;
  font-weight: 700 !important;
  line-height: 42px !important;
  background: #fffdf8 !important;
  border-bottom: 1px solid #e5ded0 !important;
  border-radius: 0 !important;
}

.user-dropdown-menu .el-dropdown-menu__item:last-child {
  border-bottom: none !important;
}

.user-dropdown-menu .el-dropdown-menu__item:hover,
.user-dropdown-menu .el-dropdown-menu__item:focus {
  color: #e03426 !important;
  background: #eeece3 !important;
}

.user-dropdown-menu .el-dropdown-menu__item.is-divided {
  margin-top: 0 !important;
  border-top: 1px solid #29251f !important;
}

.user-dropdown-menu .el-dropdown-menu__item.is-divided::before {
  display: none !important;
}

.user-dropdown-menu .el-dropdown-menu__item i {
  color: inherit !important;
}

.points-dropdown-item {
  color: #171511 !important;
  background: #faf8f0 !important;
}

.points-dropdown-item .dropdown-points-label {
  color: #70695e !important;
  letter-spacing: 0.04em;
}

.points-dropdown-item .dropdown-points-value {
  color: #fff !important;
  background: #e03426 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.points-dropdown-item:hover .dropdown-points-value {
  transform: none !important;
  box-shadow: none !important;
}

.user-dropdown-menu .el-dropdown-menu__item[data-command="logout"],
.user-dropdown-menu .el-dropdown-menu__item[data-command="logout"]:hover {
  color: #e03426 !important;
  background: #fff4f1 !important;
}

/* 响应式设计 */
@media (min-width: 1400px) {
  .navbar {
    padding: 0 20px;
  }
}

@media (max-width: 1200px) {
  .navbar {
    padding: 0 12px;
  }
  
  .navbar-left {
    gap: 16px;
    min-width: 120px;
  }
  
  .navbar-center {
    max-width: 300px;
    margin: 0 16px;
    min-width: 150px;
  }
  
  .logo-image {
    height: 28px; /* 从32px减少到28px */
  }
  
  /* 平板和小笔记本电脑使用移动端logo */
  .logo-desktop {
    display: none;
  }
  
  .logo-mobile {
    display: block;
    height: 28px !important; /* 从32px减少到28px */
  }
  
  .nav-menu-items .el-menu-item {
    padding: 0 8px !important;
    margin: 0 4px !important;
  }
  
  .nav-menu-items .el-menu-item span {
    font-size: 13px;
  }
  
  .navbar-right {
    gap: 16px;
  }
}

@media (max-width: 1024px) {
  .navbar {
    padding: 0 10px;
  }
  
  .navbar-left {
    gap: 12px;
    min-width: 100px;
  }
  
  .navbar-center {
    max-width: 250px;
    margin: 0 12px;
    min-width: 120px;
  }
  
  .logo-image {
    height: 32px;
  }
  
  /* 平板和小笔记本电脑也使用移动端logo */
  .logo-desktop {
    display: none;
  }
  
  .logo-mobile {
    display: block;
    height: 32px !important;
  }
  
  .nav-menu-items .el-menu-item {
    padding: 0 6px !important;
    margin: 0 2px !important;
  }
  
  .nav-menu-items .el-menu-item span {
    font-size: 12px;
  }
  
  .navbar-right {
    gap: 12px;
  }
}

@media (max-width: 1024px) {
  /* 平板和小笔记本电脑也使用移动端logo */
  .logo-desktop {
    display: none;
  }
  
  .logo-mobile {
    display: block;
    height: 28px !important; /* 从32px减少到28px */
  }
}

@media (max-width: 768px) {
  .el-main {
    margin-top: 60px !important; /* 移动端导航栏高度 */
  }
  
  .navbar {
    padding: 0 8px;
    min-width: 0;
    height: 60px !important; /* 增加高度 */
  }
  
  .navbar-left {
    min-width: 50px;
    gap: 4px;
    flex-shrink: 0;
  }
  
  .logo-image {
    height: 20px; /* 适当增加logo尺寸 */
  }
  
  /* 768px以下显示移动端logo */
  .logo-desktop {
    display: none;
  }
  
  .logo-mobile {
    display: block;
    height: 20px !important;
  }
  
  .navbar-center {
    margin: 0 8px;
    max-width: none;
    min-width: 100px;
    flex: 1; /* 减少搜索框的权重，给其他元素更多空间 */
  }
  
  .search-input {
    width: 100%;
  }
  
  .search-input .el-input__inner {
    padding-left: 10px;
    font-size: 13px;
    height: 34px; /* 适当增加搜索框高度 */
  }
  
  .search-input .el-input-group__append {
    padding: 0 8px;
  }
  
  .search-input .el-input-group__append .el-button {
    height: 34px;
    padding: 0;
    min-width: 34px;
  }
  
  .search-input .el-input-group__append .el-button .el-icon-search {
    font-size: 14px;
    font-weight: bold;
  }
  
  /* 768px以下隐藏桌面端菜单，显示移动端菜单 */
  .desktop-menu {
    display: none !important;
  }
  
  .mobile-menu {
    display: flex !important;
    align-items: center;
  }
  
  .navbar-right {
    flex-shrink: 0;
    gap: 8px;
    min-width: 100px; /* 确保右侧有足够空间 */
  }
  
  .user-functions {
    gap: 6px;
  }
  
  .username {
    display: none; /* 在768px以下隐藏用户名 */
  }
  
  .user-profile-trigger {
    padding: 4px 6px;
  }
  
  .user-avatar {
    width: 28px !important;
    height: 28px !important;
  }
  
  .auth-buttons {
    gap: 4px;
  }
  
  .login-btn {
    padding: 4px 6px;
    font-size: 11px;
    white-space: nowrap;
  }
  
  .register-btn {
    padding: 4px 8px;
    font-size: 11px;
    white-space: nowrap;
  }
}

@media (max-width: 480px) {
  .el-main {
    margin-top: 55px !important; /* 480px以下导航栏高度 */
  }
  
  .navbar {
    padding: 0 6px;
    height: 55px !important; /* 增加高度 */
  }
  
  .navbar-left {
    min-width: 40px;
    gap: 3px;
  }
  
  .logo-image {
    height: 18px; /* 适当增加 */
  }
  
  .navbar-center {
    margin: 0 6px;
    min-width: 80px;
    flex: 1; /* 减少搜索框权重 */
  }
  
  .search-input .el-input__inner {
    padding-left: 8px;
    font-size: 12px;
    height: 32px; /* 适当增加高度 */
  }
  
  .search-input .el-input-group__append {
    padding: 0 6px;
  }
  
  .search-input .el-input-group__append .el-button {
    height: 32px;
    min-width: 32px;
    background: #e03426 !important;
    border-color: #e03426 !important;
  }
  
  .search-input .el-input-group__append .el-button .el-icon-search {
    font-size: 13px;
    font-weight: bold;
    color: #ffffff !important;
  }
  
  /* 480px以下继续隐藏桌面端菜单，显示移动端菜单 */
  .desktop-menu {
    display: none !important;
  }
  
  .mobile-menu {
    display: flex !important;
    align-items: center;
  }
  
  .mobile-menu-trigger {
    padding: 6px 8px;
  }
  
  .mobile-menu-trigger i {
    font-size: 14px;
  }
  
  .mobile-menu-text {
    font-size: 11px;
  }
  
  .navbar-right {
    flex-shrink: 0;
    min-width: 80px; /* 确保右侧有足够空间 */
  }
  
  .user-functions {
    gap: 5px;
  }
  
  .user-avatar {
    width: 26px !important;
    height: 26px !important;
  }
  
  .auth-buttons {
    gap: 5px;
  }
  
  .login-btn {
    padding: 3px 5px;
    font-size: 10px;
  }
  
  .register-btn {
    padding: 3px 6px;
    font-size: 10px;
  }
}

@media (max-width: 360px) {
  .el-main {
    margin-top: 52px !important; /* 360px以下导航栏高度 */
  }
  
  .navbar {
    padding: 0 4px;
    height: 52px !important; /* 适当增加高度 */
  }
  
  .navbar-left {
    gap: 2px;
    min-width: 30px;
  }
  
  .logo-image {
    height: 16px; /* 适当增加logo尺寸 */
  }
  
  /* 360px以下继续显示移动端logo */
  .logo-desktop {
    display: none;
  }
  
  .logo-mobile {
    display: block;
    height: 16px !important;
  }
  
  .navbar-center {
    margin: 0 4px;
    min-width: 70px;
    flex: 1; /* 减少搜索框权重 */
  }
  
  .search-input .el-input__inner {
    padding-left: 6px;
    font-size: 11px;
    height: 30px;
  }
  
  .search-input .el-input-group__append {
    padding: 0 4px;
  }
  
  .search-input .el-input-group__append .el-button {
    height: 30px;
    min-width: 30px;
    background: #e03426 !important;
    border-color: #e03426 !important;
  }
  
  .search-input .el-input-group__append .el-button .el-icon-search {
    font-size: 12px;
    font-weight: bold;
    color: #ffffff !important;
  }
  
  /* 360px以下继续隐藏桌面端菜单，显示移动端菜单 */
  .desktop-menu {
    display: none !important;
  }
  
  .mobile-menu {
    display: flex !important;
    align-items: center;
  }
  
  .mobile-menu-trigger {
    padding: 4px 6px;
  }
  
  .mobile-menu-trigger i {
    font-size: 13px;
  }
  
  .mobile-menu-text {
    font-size: 10px;
  }
  
  .navbar-right {
    min-width: 60px; /* 确保右侧有足够空间 */
  }
  
  .user-functions {
    gap: 4px;
  }
  
  .user-avatar {
    width: 24px !important;
    height: 24px !important;
  }
  
  .login-btn {
    padding: 2px 4px;
    font-size: 9px;
  }
  
  .register-btn {
    padding: 2px 5px;
    font-size: 9px;
  }
}

@media (max-width: 320px) {
  .navbar {
    padding: 0 2px;
  }
  
  .navbar-center {
    margin: 0 2px;
    min-width: 70px;
    flex: 5; /* 在最小屏幕上最大化搜索框空间 */
  }
  
  .search-input .el-input__inner {
    padding-left: 3px;
    font-size: 9px;
    height: 26px;
  }
  
  .search-input .el-input-group__append {
    padding: 0 2px;
  }
  
  .search-input .el-input-group__append .el-button {
    height: 26px;
    min-width: 26px;
  }
  
  .search-input .el-input-group__append .el-button .el-icon-search {
    font-size: 11px;
  }
  
  .navbar-left {
    gap: 4px;
  }
  
  .logo-image {
    height: 18px;
  }
  
  .nav-menu-items .el-menu-item {
    padding: 0 2px;
  }
  
  .nav-menu-items .el-menu-item span {
    font-size: 8px;
  }
  
  .login-btn {
    padding: 2px 4px;
    font-size: 8px;
  }
  
  .register-btn {
    padding: 2px 5px;
    font-size: 8px;
  }
}
</style> 